module.exports = __webpack_public_path__ + "img/ft@3x.480c2c0b.png";